export default __webpack_public_path__ + "static/bg-70d41240e8100c16036ae7384fd89c96.jpg";